<script>
import { Bar } from "vue-chartjs";
import moment from "moment";
import patternomaly from "patternomaly";

moment.locale("de");

export default {
  name: "BigNumberFaelleZeitraumBars",
  extends: Bar,
  props: ["austria_timeline", "colors", "format"],
  inject: ["setTooltipXValue"],
  mounted() {
    this.renderChart(this.chartjs_data, this.options);
  },
  watch: {
    austria_timeline() {
      this.$nextTick(() => {
        this.$options._chart.config.data.datasets = this.chartjs_data.datasets;
        this.$options._chart.config.options = this.chartjs_options;
        this.$options._chart.update();
      });
    },
    styles() {
      this.$nextTick(() => {
        this.$options._chart.config.data.datasets = this.chartjs_data.datasets;
        this.$options._chart.config.options = this.chartjs_options;
        this.$options._chart.update();
      });
    }
  },
  computed: {
    sparkline_keys() {
      return ["davon_max_aktive", "bestätigte_Fälle_tag_diff"];
    },
    pattern_max_aktive_bl() {
      return patternomaly.draw(
        "diagonal",
        this.colors.davon_max_aktive,
        this.colors.infizierte_highlight,
        6
      );
    },
    pattern_max_aktive_bl_highlight() {
      return patternomaly.draw(
        "diagonal",
        this.colors.davon_max_aktive,
        this.colors.infizierte_highlight,
        6
      );
    },
    chartjs_data() {
      const datasets = this.sparkline_keys.map(sk => ({
        label: "",
        data: this.austria_timeline.map(d => ({
          x: d.date,
          y: parseFloat(d[sk])
        })),
        showLine: true,
        fill: false,
        pointRadius: 0,
        backgroundColor:
          sk != "davon_max_aktive"
            ? this.colors.infizierte
            : this.pattern_max_aktive_bl,

        hoverBackgroundColor:
          sk != "davon_max_aktive"
            ? this.colors.infizierte_highlight
            : this.pattern_max_aktive_bl_highlight,
        borderWidth: 0,
        clip: 2,
        spanGaps: true
      }));
      return {
        datasets: datasets //.concat(gapfill),
      };
    },
    options() {
      return {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          mode: "x"
        },
        scales: {
          xAxes: [
            {
              offset: true,
              stacked: true,
              type: "time",
              display: true,
              time: {
                unit: "day",
                parser: "YYYY-MM-DD",
                displayFormats: {
                  day: "D. MMMM"
                }
              },
              scaleLabel: {
                display: false
              },
              gridLines: {
                display: false,
                drawTicks: false
              },
              ticks: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              stacked: false,
              type: "linear",
              ticks: {
                min: 0,
                callback: () => "",
                maxTicksLimit: 11
              },
              gridLines: {
                drawTicks: false,
                color: "rgba(255,255,255,0)",
                zeroLineColor: "white",
                zeroLineWidth: 0.5
              }
            }
          ]
        },
        tooltips: {
          enabled: false,
          mode: "x",
          intersect: false,
          custom: tooltipModel => {
            this.setTooltipXValue(
              tooltipModel.opacity === 0 || tooltipModel.dataPoints.length === 0
                ? null
                : tooltipModel.dataPoints[1].xLabel
            );
            return true;
          },
          displayColors: false
        },
        layout: {
          padding: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          }
        }
      };
    }
  }
};
</script>
